export type IActions = typeof Actions

function onPrintOptionsChanged(state: boolean, name: string) {
    return { type: "CHANGE_PRINT_OPTIONS", payload: { state, name } }
}

export const Actions = {
    onPrintOptionsChanged,
}
